
import { HEADERS } from "../api";
import { $ } from "../third-party-imports";

export function getBrandList(callBackHandler:any){
    var country = window.location.href.split('/')[3].replace(/[^a-zA-Z ]/g, "") === "ca" ? "ca" : "us";
    var language = window.location.href.split('/')[3].replace(/[^a-zA-Z ]/g, "") === "ca" ? "en-ca" : "en-us";
    $.ajax({
        url: window.DEFINE_VALUE.JS_redirectUri + country+"/"+language+"/_assets/brands.json",
        type: "GET",
        headers: HEADERS,
        dataType: 'json',
        success:callBackHandler,
        error: function (e: any){
        }
    });
}
